import React, { useState } from "react";
import {
  QuestionSection,
  QuestionNumber,
  QuestionType,
  CrossButton,
  QuestionHeader,
  QuestionDropdownOuter,
  DropdownOptionsOuter,
  DropdownOptions,
  DropdownDelete,
  DropdownAdd,
  MultipleChoiceOptions,
  MultipleChoiceRadio,
  MultipleChoiceDelete,
  MultipleChoiceAdd,
  CheckBoxOptions,
  CheckBoxOptionsCheckbox,
  CheckBoxOptionsDelete,
  CheckBoxOptionsAdd,
  QuestionForAll,
} from "./styles";
import TextInput from "../../../../../common/TextInput";
import { validateText } from "../../../../../common/utils";
import Icon from "../../../../../common/Icon";
import DropDown from "../../../../../common/drop-down/QuestionDropDown";
import { cloneDeep } from "lodash";

const QuestionForm = ({
  role,
  question,
  index,
  applicationForm,
  setApplicationForm,
  programForm,
}) => {

  const key = role.toLowerCase();

  const questionTypes = [
    { value: "free-response", title: "Free Response", icon: "freeresponse" },
    { value: "radio-button", title: "Multiple Choice", icon: "multichoice" },
    { value: "checkbox", title: "Checkboxes", icon: "checkboxes" },
    { value: "dropdown", title: "Dropdown", icon: "dropdown" },
  ];

  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const [selectedType, setSelectedType] = useState(
    question?.multipleQuestion?.type || "Free Response"
  );
  const [options, setOptions] = useState(
    question?.multipleQuestion?.options || []
  );

  const [selectedQuestion, setSelectedQuestion] = useState(question?.all);

  const handleDropdownToggle = () => {
    setIsDropdownActive((prevState) => !prevState);
  };

  const handleItemClick = (item) => {
    setSelectedType(item.title);
    setIsDropdownActive(false);
    handleQuestionTypeChange(item.title);
    updateForm("multipleQuestion", {
      type: item.title,
      options,
    });
  };

  const handleQuestionChange = (newValue) => {
    updateForm("question", newValue);
  };

  const handleQuestionTypeChange = (newValue) => {
    updateForm("questionType", newValue);
  };

  const updateForm = (field, value) => {
    // const updatedQuestion = {
    //   ...applicationForm[key][index],
    //   [field]: value,
    // };

    const updatedQuestion = {
      ...question,
      [field]: value,
    };

    const shouldUpdateOptions =
      field === "questionType" &&
      ["Multiple Choice", "Checkboxes", "Dropdown"].includes(value);

    if (shouldUpdateOptions) {
      const formattedType = value.toLowerCase().replace(" ", "_");

      updatedQuestion.multipleQuestion = {
        type: formattedType,
        options,
      };
      updatedQuestion.questionType = formattedType;
    }

    if (
      updatedQuestion.multipleQuestion &&
      updatedQuestion.multipleQuestion.type === "Free Response"
    ) {
      updatedQuestion.multipleQuestion = null;
      updatedQuestion.all = false;
    }

    const updatedApplicationForm = { ...applicationForm };

    ["mentor", "mentee"].forEach((formKey) => {
      if (Array.isArray(applicationForm[formKey])) {
        updatedApplicationForm[formKey] = applicationForm[formKey].map((q) => {
          if (
            updatedQuestion.matchingHash &&
            q.matchingHash === updatedQuestion.matchingHash &&
            q.questionFor !== updatedQuestion.questionFor
          ) {
            return {
              ...q,
              all: updatedQuestion.multipleQuestion === null ? false : q.all,
            };
          }
          return q;
        });
      }
    });

    // updatedApplicationForm[key] = updatedApplicationForm[key].map(
    //   (q, cIndex) => (cIndex === index ? updatedQuestion : q)
    //   // q.id === updatedQuestion.id || q.customId === updatedQuestion.customId
    //   //   ? updatedQuestion
    //   //   : q
    // );

    updatedApplicationForm[key] = updatedApplicationForm[key].map((q) => {
      // Check if the object has 'id' and compare it
      if (q?.id && updatedQuestion?.id && q.id === updatedQuestion.id) {
        return updatedQuestion;
      }
      // If not, check if the object has 'customId' and compare it
      else if (
        q?.customId &&
        updatedQuestion?.customId &&
        q.customId === updatedQuestion.customId
      ) {
        return updatedQuestion;
      } else {
        return q;
      }
    });

    // updatedApplicationForm[key] = updatedApplicationForm[key].map((q) => {
    //   if (
    //     q?.id === updatedQuestion?.id ||
    //     q?.customId === updatedQuestion?.customId
    //   ) {
    //     return updatedQuestion;
    //   }
    //   return q;
    // });

    setApplicationForm(updatedApplicationForm);
  };

  // let newApplicationForm = {
  //   ...applicationForm,
  //   [key]: applicationForm[key].map((question, cIndex) =>
  //     cIndex === index
  //       ? { ...question, deletedAt: true, all: false }
  //       : question
  //   ),
  // };
  const handleRemoveQuestion = (qId) => {
    let newApplicationForm = {
      ...applicationForm,
      [key]: applicationForm[key]
        .map((question) => {
          if (question.id === qId) {
            return { ...cloneDeep(question), deletedAt: true, all: false }; // Modify the matched question
          } else if (!question?.id && question.customId === qId) {
            return null; // This will mark the question for removal
          } else {
            return question; // Keep other questions unchanged
          }
        })
        .filter((question) => question !== null), // Filter out the null (removed questions)
    };

    setApplicationForm(newApplicationForm);
  };

  const handleAddOption = () => {
    const updatedOptions = [...options, ""];
    setOptions(updatedOptions);
    updateForm("multipleQuestion", {
      type: selectedType,
      options: updatedOptions,
    });
  };

  const handleRemoveOption = (i) => {
    const updatedOptions = options.filter((_, index) => index !== i);
    setOptions(updatedOptions);
    updateForm("multipleQuestion", {
      type: selectedType,
      options: updatedOptions,
    });
  };

  const handleOptionChange = (i, value) => {
    const updatedOptions = options.map((opt, index) =>
      index === i ? value : opt
    );
    setOptions(updatedOptions);
    updateForm("multipleQuestion", {
      type: selectedType,
      options: updatedOptions,
    });
  };
  return (
    <QuestionSection>
      <QuestionHeader>
        {programForm?.programType === "1_1_NETWORK" ||
        applicationForm?.programType === "1_1_NETWORK" ? (
          <>
            {selectedType === "Dropdown" ||
            selectedType === "Multiple Choice" ||
            selectedType === "Checkboxes" ? (
              <QuestionForAll
                onClick={() => {
                  setSelectedQuestion((prev) => {
                    const newValue = !prev;
                    updateForm("all", newValue);
                    return newValue;
                  });
                }}
              >
                <Icon
                  type={selectedQuestion ? "star-filled" : "star-empty"}
                  size="20"
                />
              </QuestionForAll>
            ) : (
              <></>
            )}{" "}
          </>
        ) : (
          <></>
        )}
        <QuestionNumber>Question {index + 1}</QuestionNumber>
        <CrossButton
          onClick={() =>
            handleRemoveQuestion(question?.id || question?.customId)
          }
        >
          <Icon type={"cross"} size="10" color="#302F2F" />
        </CrossButton>
      </QuestionHeader>

      <QuestionType>
        <TextInput
          mobileWidthInput={"100%"}
          placeholder="Write your question here..."
          value={question.question}
          setValue={handleQuestionChange}
          isValid={validateText(question.question)}
          setIsValid={() => {}}
        />
        <QuestionDropdownOuter>
          <DropDown
            title={selectedType}
            options={questionTypes}
            handler={handleItemClick}
            isActive={isDropdownActive}
            handleDropdown={handleDropdownToggle}
            selectedOption
          />
        </QuestionDropdownOuter>
      </QuestionType>

      {selectedType === "Dropdown" && (
        <DropdownOptionsOuter>
          {options?.map((option, i) => (
            <DropdownOptions key={i}>
              <TextInput
                placeholder="Option..."
                value={option}
                setValue={(value) => handleOptionChange(i, value)}
              />
              <DropdownDelete onClick={() => handleRemoveOption(i)}>
                Delete
              </DropdownDelete>
            </DropdownOptions>
          ))}
          <DropdownAdd onClick={handleAddOption}>Add Dropdown Item</DropdownAdd>
        </DropdownOptionsOuter>
      )}

      {selectedType === "Multiple Choice" && (
        <div>
          {options?.map((option, i) => (
            <MultipleChoiceOptions key={i}>
              <MultipleChoiceRadio type="radio" disabled />
              <TextInput
                placeholder="Option text..."
                value={option}
                setValue={(value) => handleOptionChange(i, value)}
              />
              <MultipleChoiceDelete onClick={() => handleRemoveOption(i)}>
                Delete
              </MultipleChoiceDelete>
            </MultipleChoiceOptions>
          ))}
          <MultipleChoiceAdd onClick={handleAddOption}>
            Add Option
          </MultipleChoiceAdd>
        </div>
      )}

      {selectedType === "Checkboxes" && (
        <div>
          {options?.map((option, i) => (
            <CheckBoxOptions key={i}>
              <CheckBoxOptionsCheckbox type="checkbox" disabled />
              <TextInput
                placeholder="Checkbox text..."
                value={option}
                setValue={(value) => handleOptionChange(i, value)}
              />
              <CheckBoxOptionsDelete onClick={() => handleRemoveOption(i)}>
                Delete
              </CheckBoxOptionsDelete>
            </CheckBoxOptions>
          ))}
          <CheckBoxOptionsAdd onClick={handleAddOption}>
            Add Checkbox
          </CheckBoxOptionsAdd>
        </div>
      )}
    </QuestionSection>
  );
};

export default QuestionForm;
